import { ComponentType } from "@angular/cdk/portal";
import { ChangeDetectorRef } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { untilDestroyed } from "@ngneat/until-destroy";
import { Actions, ofType } from "@ngrx/effects";
import { Action, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { MessageBoxCustomButton, MessageDialogComponent } from "src/app/angular-core/components/message-dialog/message-dialog.component";
import { SaveSheetService } from "src/app/angular-core/services/save-sheet.service";
import { ITab } from "../interfaces/component.interfaces";
import { IRemoteXPACPortalState } from "../interfaces/store.interfaces";
import { MatDialogConfig, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MatTabGroup, MatTab, MatTabHeader } from "@angular/material/tabs";

export function registerDeletionListeners(component: { isDeleting: boolean, actionsListener$: Actions, cdr: ChangeDetectorRef, router: Router }, successType: string, failedType: string, route: string | (() => [string, NavigationExtras?])) {
  component.actionsListener$
    .pipe(ofType(successType))
    .pipe(untilDestroyed(component))
    .subscribe(() => {
      let target: string;
      let extras: NavigationExtras;
      if (typeof route === "string") {
        target = route;
      }
      else {
        [target, extras] = route();
      }

      component.router.navigate([target], extras);
    });

  component.actionsListener$
    .pipe(ofType(failedType))
    .pipe(untilDestroyed(component))
    .subscribe(() => {
      component.isDeleting = false;
      component.cdr.markForCheck();
    });
}

export function showDeleteItemDialog(component: { isDeleting: boolean, store: Store<IRemoteXPACPortalState>, cdr: ChangeDetectorRef, dialog: { open<T, D = any, R = any>(component: ComponentType<T>, config?: MatDialogConfig<D>): MatDialogRef<T, R>; } }, headerText: string, messageText: string, deleteAction: Action) {
  const dialogRef: MatDialogRef<MessageDialogComponent> = component.dialog.open(MessageDialogComponent, {
    panelClass: 'messagebox-dialog',
    autoFocus: false,
    data: { headerInfo: headerText, message: messageText, buttons: MessageBoxCustomButton.YesNo }
  });

  dialogRef.afterClosed().subscribe((result: boolean) => {
    if (result) {
      component.isDeleting = true;
      component.store.dispatch(deleteAction);
      component.cdr.markForCheck();
    }
  });
}

export function createInterceptTabChange(saveSheetService: SaveSheetService, translate: TranslateService, dialog: MatDialog, tabGroup: MatTabGroup): (tab: MatTab, tabHeader: MatTabHeader, idx: number) => void {
  return function (tab: MatTab, tabHeader: MatTabHeader, idx: number): void {
    if (saveSheetService.openStatus$.value) {
      const headerText: string = translate.instant('Header.NotAppliedChangesHeader');
      const messageText: string = translate.instant('Header.NotAppliedChangesMessage')

      const dialogRef: MatDialogRef<MessageDialogComponent> = dialog.open(MessageDialogComponent, {
        panelClass: 'messagebox-dialog',
        autoFocus: false,
        data: { headerInfo: headerText, message: messageText, buttons: MessageBoxCustomButton.YesNo }
      });

      dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result) {
          saveSheetService.change(false);
          return MatTabGroup.prototype._handleClick.apply(tabGroup, [tab, tabHeader, idx]);
        }
      });
    }
    else {
      return MatTabGroup.prototype._handleClick.apply(tabGroup, [tab, tabHeader, idx]);
    };
  }
}

export function createVisibleTabList(tabs: ITab[]): ITab[] {
  return tabs.filter(tab => tab.isVisible(tab.name));
}